import { useContext } from 'react';
import LanguageContext from './Context';

export const useLanguage = () => {
  const language = useContext(LanguageContext);
  return language;
};
